import { all_news_lan } from "@/components/NewsMain/Default/hooks/useNewsList";
import { getSearchParam } from ".";
export function isShowNews1() {
  const lan = getSearchParam("lan") || "";
  const channel = getSearchParam("channel") || "";
  const { subdomain } = useSubdomain();
  const dismoreChannel = ["v_ls_dismore"];
  const disnewsChannel = ["v_ls_disnews"];
  const CHANNEL_LIST = [...dismoreChannel, ...disnewsChannel];
  return {
    validMain:
      ["www.comfortweather.com"].includes(`${subdomain}.comfortweather.com`) &&
      channel &&
      CHANNEL_LIST.includes(channel) &&
      lan &&
      Object.keys(all_news_lan).includes(lan),
    isIdVls: ["id-v-ls.comfortweather.com"].includes(`${subdomain}.comfortweather.com`),
    isValidDismoreChannel:
      ["www.comfortweather.com"].includes(`${subdomain}.comfortweather.com`) &&
      channel &&
      dismoreChannel.includes(channel) &&
      lan &&
      Object.keys(all_news_lan).includes(lan),
    isValidDisnewsChannel:
      ["www.comfortweather.com"].includes(`${subdomain}.comfortweather.com`) &&
      channel &&
      disnewsChannel.includes(channel) &&
      lan &&
      Object.keys(all_news_lan).includes(lan),
  };
}
